import { render, staticRenderFns } from "./orderRadio.vue?vue&type=template&id=6fcb5c16"
import script from "./orderRadio.vue?vue&type=script&lang=js"
export * from "./orderRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports